import _ from 'lodash';
import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {HttpStatusCodes} from '../.././util/uiconstants';

export default function referenceDocumentsReducer(state = initialstate.referenceDocuments, action) {
	switch (action.type) {
		case types.GET_ALL_REFERENCE_DOCS:
			return action.response || state;
		case types.DELETE_REFERENCE_DOC:
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				let referenceDocumentsFromState = _.cloneDeep(state);

				const removedDocuments = _.remove(referenceDocumentsFromState.data, (doc) => {
					return doc.id === action.documentId;
				});

				referenceDocumentsFromState.totalEntityCount -= removedDocuments?.length || 0;
				return referenceDocumentsFromState;
			}
			return state;
		case types.ADD_REFERENCE_DOC:
			if (action.response && action.response.id > 0) {
				let referenceDocumentsFromState = _.cloneDeep(state);

				if (referenceDocumentsFromState.data && referenceDocumentsFromState.data.length > 0) {
					referenceDocumentsFromState.data.push(action.document);
				} else {
					referenceDocumentsFromState.data = [];
					referenceDocumentsFromState.data.push(action.document);
				}
				_.sortBy(referenceDocumentsFromState.data, (doc) => {
					return doc.documentName.toLowerCase();
				});

				referenceDocumentsFromState.totalEntityCount += 1;
				return referenceDocumentsFromState;
			}
			return state;
		default:
			return state;
	}
}
